exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#banner *[data-v-4e52ed0d]{line-height:0\n}\n#banner a[data-v-4e52ed0d]{display:block\n}\n#banner img[data-v-4e52ed0d]{width:100%\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e52ed0d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/NswBanner.vue
// module id = 9L0c
// module chunks = 6